import { Helmet } from "react-helmet";
import React, { useState, Component } from "react";
import { Button, Form, FormControl, Dropdown, Table, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import "../../styles/notification/notification.scss";
import { encodeQueryData } from "../../api/apiClient";
import Search from "../commoncomponents/Search";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import TimePicker from "rc-time-picker";
import { utcToLocal } from "../../utils/dateConvert";

const format = "h:mm a";

class EditNotification extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      NotificationDetail: [],
      eventList: [],
      groupList: [],
      assetList: [],
      completeAssetList: [],
      userId: "",
      groupId: "",
      groupName: "Select group",
      groupCustomerName: "",
      userName: "Select user",
      customerID: "default",
      customerName: "",
      name: "",
      name_error: false,
      user_error: false,
      description: "",
      status: "1",
      pageCount: 0,

      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "0",
      entryEnd: "0",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,

      // config
      mon: true,
      tue: true,
      wed: true,
      thu: true,
      fri: true,
      sat: true,
      sun: true,
      hours: 1,
      startPeriod: "",
      endPeriod: "",
      defaultStart: "",
      defaultEnd: "",
      email: false,
      sortString: "name",
      sortDirection: "asc",
      tempANotification: false,
      tempBNotification: false,
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
    this.checkedEvents = [];
    this.checkedAssets = [];
    this.formSubmit = false;
    this.searchText = "";
    this.groupId = "";
    this.pageSize = "10";
    this.pageKey = "1";
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    console.log("params", this.props);
    try {
      const NotificationDetail = await axios.post(
        `${apiHost}/api/Notification/SelectNotification/${this.props.match.params.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const config = JSON.parse(NotificationDetail.data.config);

      this.setState({
        NotificationDetail: NotificationDetail.data,
        userId: NotificationDetail.data.userId,
        userName: NotificationDetail.data.userName,
        customerName: NotificationDetail.data.customerName,
        name: NotificationDetail.data.name,
        description: NotificationDetail.data.description,
        tempANotification: NotificationDetail.data.tempANotification,
        tempBNotification: NotificationDetail.data.tempBNotification,
        hours: NotificationDetail.data.config.Hours,
        groupId: NotificationDetail.data.groupid,
        status: NotificationDetail.data.status,
        mon: config.Days.Monday,
        tue: config.Days.Tuesday,
        wed: config.Days.Wednesday,
        thu: config.Days.Thursday,
        fri: config.Days.Friday,
        sat: config.Days.Saturday,
        sun: config.Days.Sunday,
        email: config.Email,
        uniqueId: NotificationDetail.data.uniqueId
      });

      this.handleActiveRadio(config.Hours);
      let startTimeHour = moment.utc(config.Period.Start).get("hour");
      let startTimeMinutes = moment.utc(config.Period.Start).get("minute");
      if (startTimeHour < 10) {
        startTimeHour = "0" + startTimeHour;
      }
      if (startTimeMinutes < 10) {
        startTimeMinutes = "0" + startTimeMinutes;
      }
      // let Start = this.tConvert(`${startTimeHour}:${startTimeMinutes}`);
      let endTimeHour = moment.utc(config.Period.End).get("hour");
      let endTimeMinutes = moment.utc(config.Period.End).get("minute");
      if (endTimeHour < 10) {
        endTimeHour = "0" + endTimeHour;
      }
      if (endTimeMinutes < 10) {
        endTimeMinutes = "0" + endTimeMinutes;
      }

      var ordStartTime = moment.utc().hour(8).minute(0);
      var ordEndTime = moment.utc().hour(17).minute(0);
      var startTime = moment.utc().hour(startTimeHour).minute(startTimeMinutes);
      var endTime = moment.utc().hour(endTimeHour).minute(endTimeMinutes);
      if (isNaN(startTimeHour || startTimeMinutes || endTimeHour || endTimeMinutes)) {
        this.setState({
          defaultStart: ordStartTime,
          defaultEnd: ordEndTime,
        });
        this.onStartTimeChange(ordStartTime);
        this.onEndTimeChange(ordEndTime);
      } else {
        this.setState({
          defaultStart: startTime,
          defaultEnd: endTime,
        });
        this.onStartTimeChange(startTime);
        this.onEndTimeChange(endTime);
      }

      this.checkedEvents = NotificationDetail.data.events;
      this.checkedAssets = NotificationDetail.data.assets;

      let groupUrl = `${apiHost}/api/Notification/AllGroupForNotification?UserId=${this.state.userId}`;

      this.getGroups(groupUrl);
      console.log("NotificationDetail ", NotificationDetail.data);
      console.log(
        "checked assets from component did mount",
        this.checkedAssets
      );

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    this.props.setLoadingPageAction(true);

    try {
      const eventList = await axios.get(
        `${apiHost}/api/Notification/AllEventsForNotification`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ eventList: eventList.data });
      console.log("eventList ", eventList.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    var checkBoxes = document.getElementsByClassName("tr-eventCheckBox");

    for (var i in checkBoxes) {
      console.log("match found", checkBoxes[i]);
      for (var j in this.checkedEvents) {
        if (checkBoxes[i].value === this.checkedEvents[j]) {
          checkBoxes[i].checked = true;
          var tr = document.getElementById(`tr-${checkBoxes[i].value}`);

          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }
  }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };

  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({ sortDirection: "des" });
      this.sortDirection = "des";
    } else {
      this.setState({ sortDirection: "asc" });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.handleSort(name, order);
  };

  handleSort = (name, order) => {
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.style.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }

    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setAssetsQueryObject());
    console.log("notification group query", query);
    let urlAll = `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?${query}`;
    this.postAssets(urlAll);
  };
  getGroups = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      const groupList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ groupList: groupList.data });
      console.log("groupList ", groupList.data);
      this.state.groupList.forEach((item, index) => {
        if (item.groupId == this.state.groupId) {
          this.handleAutoGroupDropDown(
            item.groupId,
            item.groupName,
            item.customername
          );
        }
      });

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleSubmit = async () => {
    this.formSubmit = 0;
    if (this.state.name == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
      this.formSubmit++;
    }
    if (this.state.userId == "") {
      this.setState({ user_error: true });
    } else {
      this.formSubmit++;
      this.setState({ user_error: false });
    }

    if (this.formSubmit == 2) {
      var uri_enc = encodeURIComponent(
        `{"Days":{"Friday":${this.state.fri},"Monday":${this.state.mon},"Sunday":${this.state.sun},"Tuesday":${this.state.tue},"Saturday":${this.state.sat},"Thursday":${this.state.thu},"Wednesday":${this.state.wed}},"Email":${this.state.email},"Hours":"${this.state.hours}","Period":{"End":"${this.state.endPeriod}","Start":"${this.state.startPeriod}"},"GroupID":"${this.state.groupId}"}`
      );

      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Notification/Update`,
          {
            Id: this.props.match.params.id,
            UserId: this.state.userId,
            Name: this.state.name,
            Description: this.state.description,
            config: uri_enc,
            status: this.state.status,
            GroupId: this.state.groupId,
            EventId: this.checkedEvents,
            AssetId: this.checkedAssets,
            dbUpdated: this.state.NotificationDetail.dbUpdated,
            dbCreated: this.state.NotificationDetail.dbCreated,
            TempANotification: this.state.tempANotification,
            TempBNotification: this.state.tempBNotification,
            UniqueId:this.state.uniqueId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.props.history.goBack();
        console.log("notification ", response.data);

        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  };

  handleUserDropDown = (userId, userName, customerName) => {
    this.setState({
      userId: userId,
      userName: userName,
      customerName: customerName,
    });
    let groupUrl = `${apiHost}/api/Notification/AllGroupForNotification?UserId=${userId}`;
    this.getGroups(groupUrl);
    this.setState({
      groupId: "",
      groupName: "Select group",
      groupCustomerName: "",
      assetList: [],
    });
  };

  handleNameChange = (e) => {
    this.setState({ name_error: e.target.value == "" });
    this.setState({ name: e.target.value });
  };

  handleDescriptionChange = (e) => {
    console.log(e.target.value);
    this.setState({ description: e.target.value });
  };

  handleDayCheckBox = (e) => {
    let dayCheckbox = document.getElementsByClassName("day");

    for (var i in dayCheckbox) {
      switch (dayCheckbox[i].value) {
        case "mon": this.setState({ mon: dayCheckbox[i].checked }); break;
        case "tue": this.setState({ tue: dayCheckbox[i].checked }); break;
        case "wed": this.setState({ wed: dayCheckbox[i].checked }); break;
        case "thu": this.setState({ thu: dayCheckbox[i].checked }); break;
        case "fri": this.setState({ fri: dayCheckbox[i].checked }); break;
        case "sat": this.setState({ sat: dayCheckbox[i].checked }); break;
        case "sun": this.setState({ sun: dayCheckbox[i].checked }); break;
        default: break;
      }
    }
  };

  handleActiveRadio = (hour) => {
    this.setState({ hours: hour });
    let input = document.getElementsByClassName("timePeriod");
    input[0].style.pointerEvents = input[1].style.pointerEvents = hour == 1 ? "none" : "auto";
  };

  handleActiveRadioFromEvent = (e) => {
    this.handleActiveRadio(e.target.value);
  };

  onStartTimeChange = (value) => {
    this.setState({
      startPeriod: moment.utc(value).format(),
    });
  };

  onEndTimeChange = (value) => {
    this.setState({
      endPeriod: moment.utc(value).format(),
    });
  };

  handleEmail = () => {
    let email = document.getElementById("emailBox");
    if (email.checked) {
      this.setState({ email: true });
    } else {
      this.setState({ email: false });
    }
  };

  handleStatus = (e) => {
    this.setState({ status: e.target.value });
  };

  handleCheckbox = (e, id, checkedList) => {
    var checkbox = document.getElementById(id);

    checkbox.checked = !checkbox.checked;

    var tr = document.getElementById(`tr-${id}`);
    if (tr.bgColor == "#999999") {
      tr.bgColor = "#FFFFFF";
      tr.style.color = "#212529";
    } else {
      tr.bgColor = "#999999";
      tr.style.color = "#FFFFFF";
    }

    if (checkbox.checked) {
      checkedList.push(id);
    } else {
      const index = checkedList.indexOf(id);
      checkedList.splice(index, 1);
    }
  };

  handleAssetsCheckBox = (e, assetid) => {
    var assetsCheckbox = document.getElementById(assetid);

    if (assetsCheckbox.checked == true) {
      assetsCheckbox.checked = false;
    } else {
      assetsCheckbox.checked = true;
    }

    var tr = document.getElementById(`tr-${assetid}`);
    if (tr.bgColor == "#999999") {
      tr.bgColor = "#FFFFFF";
      tr.style.color = "#212529";
    } else {
      tr.bgColor = "#999999";
      tr.style.color = "#FFFFFF";
    }

    if (assetsCheckbox.checked) {
      this.checkedAssets.push(assetid);
    } else {
      const index = this.checkedAssets.indexOf(assetid);

      this.checkedAssets.splice(index, 1);
    }
  };

  setAssetsQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;

    return data;
  };

  handlePagination = (page) => {
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.style.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }
    this.pageKey = page;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?${query}`;
    this.postAssets(urlAll);
  };

  handleSearch = (inputSearch) => {
    var checkBoxes = document.getElementsByClassName("tr-checkBox");
    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.style.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }

    //filtered by message on showing results
    this.setState({ filterMessage: inputSearch != "" });

    this.searchText = inputSearch;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?${query}`;
    if (this.state.groupId != "") {
      this.postAssets(urlAll);
    }
  };

  handleAutoGroupDropDown = async (groupId, groupName, gcustomerName) => {
    this.setState({
      groupId: groupId,
      groupName: groupName,
      groupCustomerName: gcustomerName,
    });

    this.groupId = groupId;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let url = `${apiHost}/api/Notification/AssetsByGroupId/${groupId}?${query}`;
    this.postAssets(url);
  };

  handleGroupDropDown = async (groupId, groupName, gcustomerName) => {
    this.checkedAssets = [];

    this.setState({
      groupId: groupId,
      groupName: groupName,
      groupCustomerName: gcustomerName,
    });

    this.groupId = groupId;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let url = `${apiHost}/api/Notification/AssetsByGroupIdForNotification/${groupId}?${query}`;
    this.postAssets(url);
  };

  postAssets = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      const assetList = await axios.get(
        url,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        assetList: assetList.data.paggedlist,
        pageCount: JSON.parse(assetList.headers.pagination).totalPages,
      });
      this.handleShowResults(assetList);
      this.completeAssetList = assetList.data.includedelements;
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    var checkBoxes = document.getElementsByClassName("tr-checkBox");

    for (var i in checkBoxes) {
      for (var j in this.checkedAssets) {
        if (checkBoxes[i].value === this.checkedAssets[j]) {
          checkBoxes[i].checked = true;
          var tr = document.getElementById(`tr-${checkBoxes[i].value}`);

          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }
  };
  handleShowResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(response.headers.pagination).totalItems,
    });

    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(response.headers.pagination).totalItems,
        totalFilter: true,
      });
    }

    this.setState({
      entryStart: (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });

    if (JSON.parse(response.headers.pagination).totalItems < parseInt(this.state.entryEnd)) {
      this.setState({ entryEnd: JSON.parse(response.headers.pagination).totalItems });
    } else {
      this.setState({ entryEnd: parseInt(JSON.parse(response.headers.pagination).currentPage) * parseInt(this.pageSize) });
    }

    if (this.state.entryEnd > parseInt(JSON.parse(response.headers.pagination).totalItems)) {
      this.setState({ entryEnd: JSON.parse(response.headers.pagination).totalItems });
    }

    if (this.state.assetList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };

  handleSelectAll = () => {
    this.checkedAssets = this.completeAssetList;
    let query = encodeQueryData(this.setAssetsQueryObject());

    let url = `${apiHost}/api/Notification/AssetsByGroupId/${this.state.groupId}?${query}`;
    this.postAssets(url);
  };

  handleDeselectAll = () => {
    this.checkedAssets = [];
    let query = encodeQueryData(this.setAssetsQueryObject());
    var checkBoxes = document.getElementsByClassName("tr-checkBox");

    for (var i in checkBoxes) {
      if (checkBoxes[i].checked) {
        checkBoxes[i].checked = false;
        var tr = document.getElementById(`tr-${checkBoxes[i].value}`);
        if (tr.bgColor == "#999999") {
          tr.bgColor = "#FFFFFF";
          tr.style.color = "#212529";
        } else {
          tr.bgColor = "#999999";
          tr.style.color = "#FFFFFF";
        }
      }
    }

    let url = `${apiHost}/api/Notification/AssetsByGroupId/${this.state.groupId}?${query}`;
    this.postAssets(url);
  };

  handleTempANotification = (evt) => {
    this.setState({ tempANotification: evt.target.value == "ON" });
  };
  handleTempBNotification = (evt) => {
    this.setState({ tempBNotification: evt.target.value == "ON" });
  };
  render() {
    const AssetsToggle = React.forwardRef(({ children, onClick }, ref) => (
      <button
        className="long-button-button"
        href=""
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}

        <i className="fa fa-th" />
      </button>
    ));

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    const CustomMenu = React.forwardRef(
      ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
        const [value, setValue] = useState("");

        return (
          <div
            ref={ref}
            style={style}
            className={className}
            aria-labelledby={labeledBy}
          >
            <FormControl
              autoFocus
              className="mx-3 my-2 w-auto"
              placeholder="Type to filter..."
              onChange={(e) => setValue(e.target.value)}
              value={value}
              autoComplete="off"
            />
            <ul className="list-unstyled">
              {React.Children.toArray(children).filter(
                (child) =>
                  !value || child.props.children.toLowerCase().includes(value)
              )}
            </ul>
          </div>
        );
      }
    );

    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit Notification </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Edit Notification</h2>
              {/* <h6>Create a new user</h6> */}
              <hr></hr>
              <div className="long-dropdown">
                <Form>
                  {localStorage.getItem("role") == "SystemAdmin" && (
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={2}>
                        <span className="inline-input"> User</span>
                      </Form.Label>
                      <Col sm={10}>
                        <Form.Control
                          type="text"
                          value={`${this.state.userName}-${this.state.customerName}`}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  )}

                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Name</span>
                    </Form.Label>
                    <Col sm={3}>
                      <Form.Control
                        type="text"
                        placeholder="That identifies this notification"
                        onChange={this.handleNameChange}
                        value={this.state.name}
                      />
                      <p
                        style={
                          this.state.name_error
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Name field is required.
                      </p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Unique Id</span>
                    </Form.Label>
                    <Col sm={3}>
                      <Form.Control
                        type="text"
                        value={this.state.uniqueId}
                        disabled
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Description</span>
                    </Form.Label>
                    <Col sm={10}>
                      <Form.Control
                        as="textarea"
                        value={this.state.description}
                        placeholder="Optional short description that describes this notification"
                        onChange={this.handleDescriptionChange}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Active Days</span>
                    </Form.Label>

                    <Col sm={10}>
                      <div className="resposition">
                        <Row>
                          <input
                            type="checkbox"
                            className="day"
                            value="mon"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.mon}
                          />{" "}
                          Monday&nbsp;
                          <input
                            type="checkbox"
                            className="day"
                            value="tue"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.tue}
                          />{" "}
                          Tuesday &nbsp;
                          <input
                            type="checkbox"
                            className="day"
                            value="wed"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.wed}
                          />{" "}
                          Wednesday &nbsp;
                          <input
                            type="checkbox"
                            className="day"
                            value="thu"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.thu}
                          />{" "}
                          Thursday&nbsp;
                          <input
                            type="checkbox"
                            className="day"
                            value="fri"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.fri}
                          />{" "}
                          Friday &nbsp;
                          <input
                            type="checkbox"
                            className="day"
                            value="sat"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.sat}
                          />{" "}
                          Saturday &nbsp;
                          <input
                            type="checkbox"
                            className="day"
                            value="sun"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.sun}
                          />{" "}
                          Sunday &nbsp;
                        </Row>
                      </div>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Active Hours</span>
                    </Form.Label>
                    <Col sm={10}>
                      <div className="resposition">
                        <Row>
                          {" "}
                          <input
                            type="radio"
                            name="period"
                            value="1"
                            className="hours"
                            onChange={this.handleActiveRadioFromEvent}
                            checked={this.state.hours == 1 ? true : false}
                          />{" "}
                          All day (24 hrs) &nbsp;{" "}
                        </Row>
                      </div>
                      <Row>
                        {" "}
                        <input
                          type="radio"
                          name="period"
                          value="2"
                          className="hours"
                          onChange={this.handleActiveRadioFromEvent}
                          checked={this.state.hours == 2 ? true : false}
                        />{" "}
                        Within the specified period &nbsp;
                      </Row>
                      <Row>
                        {" "}
                        <input
                          type="radio"
                          name="period"
                          value="3"
                          className="hours"
                          onChange={this.handleActiveRadioFromEvent}
                          checked={this.state.hours == 3 ? true : false}
                        />{" "}
                        Outside the specified period &nbsp;
                      </Row>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Specific period</span>
                    </Form.Label>
                    <Col sm={10}>
                      <Row>
                        <Col sm={2}>
                          <Row>From</Row>
                          <Row>
                            <div className="timePeriod">
                              <span className="fa fa-clock-o" />
                              {this.state.defaultStart != "" && (
                                <TimePicker
                                  showSecond={false}
                                  defaultValue={this.state.defaultStart}
                                  className="timePicker overlay"
                                  onChange={this.onStartTimeChange}
                                  format={format}
                                  use12Hours
                                  inputReadOnly
                                />
                              )}
                            </div>
                          </Row>
                        </Col>
                        <Col sm={2}>
                          <Row>Until</Row>
                          <Row>
                            <div className="timePeriod">
                              <span className="fa fa-clock-o" />
                              {this.state.defaultStart != "" && (
                                <TimePicker
                                  showSecond={false}
                                  defaultValue={this.state.defaultEnd}
                                  className="timePicker overlay"
                                  onChange={this.onEndTimeChange}
                                  format={format}
                                  use12Hours
                                  inputReadOnly
                                />
                              )}
                            </div>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={7}>
                          <p className="desc">
                            Defines the time period (for each day) for when
                            notifications can be created.
                            <br /> <b>Within</b> will notify if an event occurs
                            inside the From and Until period.
                            <br /> <b>Outside </b>
                            will notify if an event occurs outside the From and
                            Until period.
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Options</span>
                    </Form.Label>
                    <Col sm={6}>
                      <div className="resposition">
                        <Row>
                          <input
                            type="checkbox"
                            id="emailBox"
                            onChange={this.handleEmail}
                            checked={this.state.email}
                          />{" "}
                          Receive email&nbsp;
                        </Row>
                      </div>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      <span className="inline-input">Status</span>
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        as="select"
                        value={this.state.status}
                        onChange={this.handleStatus}
                      >
                        {console.log("statuis not", this.state.status)}

                        <option value="1">Active</option>
                        <option value="0">Disable</option>
                      </Form.Control>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      <span className="inline-input">Events</span>
                    </Form.Label>
                    <Col sm="10">
                      <Table responsive>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Updated</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.eventList.map((event, index) => {
                            return (
                              <tr
                                key={index}
                                bgcolor="#FFFFFF"
                                value={event.id}
                                id={`tr-${event.id}`}
                                onClick={(e) => this.handleCheckbox(e, event.id, this.checkedEvents)}
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    value={event.id}
                                    className="tr-eventCheckBox"
                                    id={event.id}
                                    style={{ pointerEvents: "none" }}
                                  />
                                </td>
                                <td>{event.name}</td>
                                <td>{event.description}</td>
                                <td>{event.type}</td>
                                <td>{event.status}</td>
                                <td>{utcToLocal(event.dbUpdated)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input"> Assets</span>
                    </Form.Label>
                    <Col sm={10}>
                      <Dropdown>
                        <Dropdown.Toggle
                          as={AssetsToggle}
                          style={{ width: "100px" }}
                          value={this.state.groupId}
                          id="dropdown-custom-components"
                        >
                          {this.state.groupName}{" "}
                          {this.state.groupCustomerName != ""
                            ? `-${this.state.groupCustomerName}`
                            : ""}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          as={CustomMenu}
                          value={this.state.groupId}
                        >
                          {this.state.groupList.map((item, index) => {
                            return (
                              <Dropdown.Item
                                value={item.groupId}
                                className={
                                  this.state.groupId == `${item.groupId}`
                                    ? "active"
                                    : ""
                                }
                                onClick={() => {
                                  this.handleGroupDropDown(
                                    item.groupId,
                                    item.groupName,
                                    item.customername
                                  );
                                }}
                              >
                                {`${item.groupName} - ${item.customername}`}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                      <div className="assettable">
                        <div className="inline">
                          <div>
                            <input
                              type="button"
                              onClick={this.handleSelectAll}
                              value="Select all"
                            ></input>
                            &nbsp;
                            <input
                              type="button"
                              onClick={this.handleDeselectAll}
                              value="Select none"
                            ></input>
                            &nbsp;
                          </div>

                          <Search searchCallback={this.handleSearch}></Search>
                        </div>
                        <Table responsive>
                          <thead>
                            <tr>
                              <th></th>
                              <th>
                                Name{" "}
                                {this.state.sortString == "name" ? (
                                  <i
                                    onClick={this.handleSortDirection}
                                    className={`fa ${this.state.sortDirection == "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                      }`}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-exchange"
                                    onClick={() => {
                                      this.handleSortString("name");
                                    }}
                                  />
                                )}
                              </th>
                              <th>Description</th>
                              <th>
                                Profile{" "}
                                {this.state.sortString == "profile" ? (
                                  <i
                                    onClick={this.handleSortDirection}
                                    className={`fa ${this.state.sortDirection == "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                      }`}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-exchange"
                                    onClick={() => {
                                      this.handleSortString("profile");
                                    }}
                                  />
                                )}
                              </th>
                              <th>Status</th>
                              <th>
                                Updated{" "}
                                {this.state.sortString == "updated" ? (
                                  <i
                                    onClick={this.handleSortDirection}
                                    className={`fa ${this.state.sortDirection == "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                      }`}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-exchange"
                                    onClick={() => {
                                      this.handleSortString("updated");
                                    }}
                                  />
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.assetList == "" ? (
                              <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}>
                                  "No data available in table"
                                </td>
                              </tr>
                            ) : (
                              this.state.assetList.map((item, index) => {
                                return (
                                  <tr
                                    key={index}
                                    bgcolor="#FFFFFF"
                                    id={`tr-${item.assetId}`}
                                    onClick={(e) => this.handleCheckbox(e, item.assetId, this.checkedAssets)}
                                  >
                                    <td>
                                      <input
                                        className="tr-checkBox"
                                        value={item.assetId}
                                        type="checkbox"
                                        id={item.assetId}
                                        style={{ pointerEvents: "none" }}
                                      />
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>{item.profile}</td>
                                    <td>{item.status}</td>
                                    <td>{utcToLocal(item.dbUpdated)}</td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </Table>
                        <div className="paginationDetails">
                          <ShowingResults
                            currentEntryStart={this.state.entryStart}
                            currentEntryEnd={this.state.entryEnd}
                            totalEntries={this.state.totalEntry}
                            totalFilterEntries={this.state.totalEntryFilter}
                            filterMessage={this.state.filterMessage}
                          />
                          <Paginations
                            onPagination={this.handlePagination}
                            pageCount={this.state.pageCount}
                            pageRange={5}
                          ></Paginations>
                        </div>
                      </div>
                    </Col>
                  </Form.Group>
                </Form>
              </div>
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    //this.props.history.push("/notifications");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button size="sm" variant="primary" onClick={this.handleSubmit}>
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditNotification);
